import React from 'react';
import { HiClock, HiSparkles, HiEnvelope } from 'react-icons/hi2';
import { FaRocket, FaTools } from 'react-icons/fa';
import { SUPPORT_CONTACT } from '../common/utils';

const ComingSoon = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-yellow-50 to-orange-100 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full text-center">
        {/* Animated Icon */}
        <div className="mb-8 flex justify-center">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-orange-400 to-yellow-400 rounded-full blur-2xl opacity-50 animate-pulse"></div>
            <div className="relative bg-gradient-to-br from-orange-500 to-yellow-500 rounded-full p-8 shadow-2xl">
              <FaRocket className="text-6xl text-white animate-bounce" />
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 border border-orange-100">
          <div className="flex items-center justify-center gap-2 mb-4">
            <HiSparkles className="text-3xl text-orange-500 animate-pulse" />
            <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-orange-600 to-yellow-600 bg-clip-text text-transparent">
              Coming Soon
            </h1>
            <HiSparkles className="text-3xl text-yellow-500 animate-pulse" />
          </div>

          <p className="text-xl md:text-2xl text-gray-700 mb-6 font-semibold">
            We're working on something amazing!
          </p>

          <p className="text-base md:text-lg text-gray-600 mb-8 leading-relaxed">
            Our team is putting the finishing touches on a brand new experience. 
            We'll be back soon with exciting updates and improvements.
          </p>

          {/* Features Preview */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
            <div className="bg-gradient-to-br from-orange-50 to-yellow-50 rounded-xl p-4 border border-orange-200">
              <HiClock className="text-3xl text-orange-500 mx-auto mb-2" />
              <p className="text-sm font-semibold text-gray-700">Stay Tuned</p>
            </div>
            <div className="bg-gradient-to-br from-yellow-50 to-orange-50 rounded-xl p-4 border border-yellow-200">
              <FaTools className="text-3xl text-yellow-500 mx-auto mb-2" />
              <p className="text-sm font-semibold text-gray-700">Under Development</p>
            </div>
            <div className="bg-gradient-to-br from-orange-50 to-yellow-50 rounded-xl p-4 border border-orange-200">
              <HiSparkles className="text-3xl text-orange-500 mx-auto mb-2" />
              <p className="text-sm font-semibold text-gray-700">Exciting Updates</p>
            </div>
          </div>

          {/* Contact Info */}
          <div className="bg-gradient-to-r from-orange-100 to-yellow-100 rounded-xl p-6 border border-orange-200">
            <div className="flex items-center justify-center gap-2 mb-3">
              <HiEnvelope className="text-2xl text-orange-600" />
              <h3 className="text-lg font-bold text-gray-900">Get Notified</h3>
            </div>
            <p className="text-sm text-gray-700 mb-4">
              Want to be the first to know when we launch? Contact us for updates!
            </p>
            <a
              href={`https://wa.me/${SUPPORT_CONTACT.phoneNumber}?text=${encodeURIComponent(SUPPORT_CONTACT.whatsappMessage)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white rounded-xl font-semibold transition-all duration-200 hover:shadow-lg transform hover:scale-105"
            >
              <HiEnvelope className="text-xl" />
              <span>Contact Us</span>
            </a>
          </div>

          {/* Animated Dots */}
          <div className="flex justify-center gap-2 mt-8">
            <div className="w-3 h-3 bg-orange-500 rounded-full animate-bounce" style={{ animationDelay: '0s' }}></div>
            <div className="w-3 h-3 bg-yellow-500 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
            <div className="w-3 h-3 bg-orange-500 rounded-full animate-bounce" style={{ animationDelay: '0.4s' }}></div>
          </div>
        </div>

        {/* Footer */}
        <p className="mt-8 text-sm text-gray-500">
          © {new Date().getFullYear()} All rights reserved
        </p>
      </div>
    </div>
  );
};

export default ComingSoon;
